module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button",
    style: ('background-color:' + _vm.info.color + '; border-color: ' + _vm.info.color),
    on: {
      "click": function($event) {
        _vm.onclickFilter($event);
      }
    }
  }, [_c('span', {
    class: _vm.status === -1 ? 'text-dark' : ''
  }, [_vm._v(_vm._s(_vm.short ? _vm.info.label.charAt(0).toUpperCase() : _vm.info.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f62120d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ForecastStatus.vue
// module id = 3401
// module chunks = 0